'use client';

import { c as _c } from "react/compiler-runtime";
import ListAlt from '@mui/icons-material/ListAlt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ChecklistIcon from '@mui/icons-material/Checklist';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import Source from '@mui/icons-material/Source';
import Warehouse from '@mui/icons-material/Warehouse';
import OilBarrel from '@mui/icons-material/OilBarrel';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Engineering from '@mui/icons-material/Engineering';
import HubRounded from '@mui/icons-material/HubRounded';
import HomeIcon from '@mui/icons-material/Home';
import DeveloperBoardRounded from '@mui/icons-material/DeveloperBoardRounded';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import TableChartIcon from '@mui/icons-material/TableChart';
import PrecisionManufacturing from '@mui/icons-material/PrecisionManufacturingRounded';
import FolderIcon from '@mui/icons-material/Folder';
import SettingsApplications from '@mui/icons-material/SettingsApplicationsRounded';
import DvrIcon from '@mui/icons-material/Dvr';
import Work from '@mui/icons-material/WorkOutline';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import Announcement from '@mui/icons-material/Announcement';
import Badge from '@mui/material/Badge';
import * as colors from '@mui/material/colors';
import { SideMenuItem } from '@/app/_components/SideMenuItem';
import { ROUTES } from '@/app/routes';
import { type FC } from 'react';
import { SideMenuGroup } from '@/app/_components/SideMenuGroup';
import { useUser } from '@/app/_shared/hooks/useUser';
import { QuestionAnswer } from '@mui/icons-material';
interface SideMenuPages {
  isMenuOpen: boolean;
}
const CommonPages: FC<SideMenuPages> = t0 => {
  const $ = _c(3);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RequestQuoteIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMenuOpen) {
    t2 = <><SideMenuItem isMenuOpen={isMenuOpen} icon={t1} route={ROUTES.opportunities.base}>Opportunity List</SideMenuItem></>;
    $[1] = isMenuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const HomePage: FC<SideMenuPages> = t0 => {
  const $ = _c(3);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HomeIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMenuOpen) {
    t2 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t1} route={ROUTES.ppt.base}>Home</SideMenuItem>;
    $[1] = isMenuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const JobPages: FC<SideMenuPages> = t0 => {
  const $ = _c(9);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Work />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMenuOpen) {
    t2 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t1} route={ROUTES.ppt.jobs}>Job List</SideMenuItem>;
    $[1] = isMenuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ListAlt />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMenuOpen) {
    t4 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t3} route={ROUTES.ppt.sheets}>PPT List</SideMenuItem>;
    $[4] = isMenuOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export const GuestPages: FC<SideMenuPages> = t0 => {
  const $ = _c(12);
  const {
    isMenuOpen
  } = t0;
  const {
    jmtAccess,
    qmtAccess
  } = useUser();
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <HomePage isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMenuOpen || $[3] !== qmtAccess) {
    t2 = qmtAccess && <CommonPages isMenuOpen={isMenuOpen} />;
    $[2] = isMenuOpen;
    $[3] = qmtAccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isMenuOpen || $[6] !== jmtAccess) {
    t3 = jmtAccess && <JobPages isMenuOpen={isMenuOpen} />;
    $[5] = isMenuOpen;
    $[6] = jmtAccess;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const UserPages: FC<SideMenuPages> = t0 => {
  const $ = _c(12);
  const {
    isMenuOpen
  } = t0;
  const {
    jmtAccess,
    qmtAccess
  } = useUser();
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <HomePage isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMenuOpen || $[3] !== qmtAccess) {
    t2 = qmtAccess && <CommonPages isMenuOpen={isMenuOpen} />;
    $[2] = isMenuOpen;
    $[3] = qmtAccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isMenuOpen || $[6] !== jmtAccess) {
    t3 = jmtAccess && <JobPages isMenuOpen={isMenuOpen} />;
    $[5] = isMenuOpen;
    $[6] = jmtAccess;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const SiteManagerPages: FC<SideMenuPages> = t0 => {
  const $ = _c(12);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Source />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isMenuOpen) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.ppt.recipes}>Recipes</SideMenuItem>;
    $[3] = isMenuOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PrecisionManufacturing />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isMenuOpen) {
    t5 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t4} route={ROUTES.ppt.workstations}>Workstations</SideMenuItem>;
    $[6] = isMenuOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t5) {
    t6 = <>{t1}{t3}{t5}</>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export const AdminPages: FC<SideMenuPages & {
  newSuggestionsCount?: number;
}> = t0 => {
  const $ = _c(96);
  const {
    isMenuOpen,
    newSuggestionsCount
  } = t0;
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AttachMoneyIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DvrIcon />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMenuOpen) {
    t4 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t3} route={ROUTES.operations.base}>Operations</SideMenuItem>;
    $[4] = isMenuOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FolderIcon />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isMenuOpen) {
    t6 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t5} route={ROUTES.technologies.base}>Technologies</SideMenuItem>;
    $[7] = isMenuOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SavedSearchIcon />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isMenuOpen) {
    t8 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t7} route={ROUTES.lookups.base}>Lookup Tables</SideMenuItem>;
    $[10] = isMenuOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChecklistIcon />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isMenuOpen) {
    t10 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t9} route={ROUTES.coreSections.base}>Core Formulas</SideMenuItem>;
    $[13] = isMenuOpen;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t11 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t2} title="Pricing Admin">{t4}{t6}{t8}{t10}</SideMenuGroup>;
    $[15] = isMenuOpen;
    $[16] = t10;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== newSuggestionsCount) {
    t12 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><RequestQuoteIcon sx={{
        color: colors.yellow[500]
      }} /></Badge> : <RequestQuoteIcon />;
    $[21] = newSuggestionsCount;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FactCheckIcon />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isMenuOpen) {
    t14 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t13} route={ROUTES.assumptions.base}>Assumptions</SideMenuItem>;
    $[24] = isMenuOpen;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <TableChartIcon />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== isMenuOpen) {
    t16 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t15} route={ROUTES.dataStore.base}>Data Store</SideMenuItem>;
    $[27] = isMenuOpen;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <PriceChangeIcon />;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== isMenuOpen) {
    t18 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t17} route={ROUTES.standardPrices.base}>Standard Prices</SideMenuItem>;
    $[30] = isMenuOpen;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ReceiptIcon />;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== isMenuOpen) {
    t20 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t19} route={ROUTES.quoteTypes.base}>Quote Types</SideMenuItem>;
    $[33] = isMenuOpen;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== newSuggestionsCount) {
    t21 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><Announcement sx={{
        color: colors.yellow[500]
      }} /></Badge> : <QuestionAnswer />;
    $[35] = newSuggestionsCount;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== isMenuOpen || $[38] !== t21) {
    t22 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t21} route={ROUTES.suggestions.base}>QMT Suggestions</SideMenuItem>;
    $[37] = isMenuOpen;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== isMenuOpen || $[41] !== t12 || $[42] !== t14 || $[43] !== t16 || $[44] !== t18 || $[45] !== t20 || $[46] !== t22) {
    t23 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t12} title="Quoting Admin">{t14}{t16}{t18}{t20}{t22}</SideMenuGroup>;
    $[40] = isMenuOpen;
    $[41] = t12;
    $[42] = t14;
    $[43] = t16;
    $[44] = t18;
    $[45] = t20;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <EngineeringIcon />;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <DeveloperBoardRounded />;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== isMenuOpen) {
    t26 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t25} route={ROUTES.ppt.operations}>Operations</SideMenuItem>;
    $[50] = isMenuOpen;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Source />;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== isMenuOpen) {
    t28 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t27} route={ROUTES.ppt.recipes}>Recipes</SideMenuItem>;
    $[53] = isMenuOpen;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <HubRounded />;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== isMenuOpen) {
    t30 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t29} route={ROUTES.ppt.coreSections}>Core Sections</SideMenuItem>;
    $[56] = isMenuOpen;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SettingsApplications />;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== isMenuOpen) {
    t32 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t31} route={ROUTES.ppt.editTemplate}>Edit PPT Template</SideMenuItem>;
    $[59] = isMenuOpen;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== isMenuOpen || $[62] !== t26 || $[63] !== t28 || $[64] !== t30 || $[65] !== t32) {
    t33 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t24} title="Job Admin">{t26}{t28}{t30}{t32}</SideMenuGroup>;
    $[61] = isMenuOpen;
    $[62] = t26;
    $[63] = t28;
    $[64] = t30;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <AssuredWorkloadIcon />;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Warehouse />;
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  let t36;
  if ($[69] !== isMenuOpen) {
    t36 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t35} route={ROUTES.ppt.sites}>Sites</SideMenuItem>;
    $[69] = isMenuOpen;
    $[70] = t36;
  } else {
    t36 = $[70];
  }
  let t37;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <OilBarrel />;
    $[71] = t37;
  } else {
    t37 = $[71];
  }
  let t38;
  if ($[72] !== isMenuOpen) {
    t38 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t37} route={ROUTES.ppt.materials}>Materials</SideMenuItem>;
    $[72] = isMenuOpen;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Engineering />;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] !== isMenuOpen) {
    t40 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t39} route={ROUTES.ppt.engineers.base}>Engineers</SideMenuItem>;
    $[75] = isMenuOpen;
    $[76] = t40;
  } else {
    t40 = $[76];
  }
  let t41;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <PrecisionManufacturing />;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] !== isMenuOpen) {
    t42 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t41} route={ROUTES.ppt.workstations}>Workstations</SideMenuItem>;
    $[78] = isMenuOpen;
    $[79] = t42;
  } else {
    t42 = $[79];
  }
  let t43;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <QuestionAnswer />;
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] !== isMenuOpen) {
    t44 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t43} route={ROUTES.ppt.suggestions}>JMT Suggestions</SideMenuItem>;
    $[81] = isMenuOpen;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] !== isMenuOpen || $[84] !== t36 || $[85] !== t38 || $[86] !== t40 || $[87] !== t42 || $[88] !== t44) {
    t45 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t34} title="General Admin">{t36}{t38}{t40}{t42}{t44}</SideMenuGroup>;
    $[83] = isMenuOpen;
    $[84] = t36;
    $[85] = t38;
    $[86] = t40;
    $[87] = t42;
    $[88] = t44;
    $[89] = t45;
  } else {
    t45 = $[89];
  }
  let t46;
  if ($[90] !== t1 || $[91] !== t11 || $[92] !== t23 || $[93] !== t33 || $[94] !== t45) {
    t46 = <>{t1}{t11}{t23}{t33}{t45}</>;
    $[90] = t1;
    $[91] = t11;
    $[92] = t23;
    $[93] = t33;
    $[94] = t45;
    $[95] = t46;
  } else {
    t46 = $[95];
  }
  return t46;
};